module.exports = __webpack_public_path__ + "img/reference-icon-2.6aab5517.png";